   // src/store.js
   import { createStore } from 'redux';
   import rootReducer from './reducers'; // Adjust the path to your root reducer

   const store = createStore(rootReducer);

   export default store;
   